import { Actioner } from "@services/actioner";
import type { IAddressSuggestionConstructorParams } from "@services/sdk";
import type { AxiosInstance, AxiosResponse } from "axios";

import type { IPSMAAdapter } from "@services/sdk/interfaces";
import type { ID } from "@services/sdk/types";

import {
	Address,
	AddressSuggestion,
	type IPSMAAddress,
} from "@services/sdk/models";
import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import Result, {
	type AddressResult,
	type ArrayAddressSuggestionResult,
} from "@services/sdk/models/result";

interface AddressSuggestionsResponse {
	suggest: Array<IAddressSuggestionConstructorParams>;
}

interface PSMAAddressResponse {
	address: IPSMAAddress;
}

export const createPSMAAdapter = (httpClient: AxiosInstance): IPSMAAdapter => ({
	getAddressSuggestions: async (
		query: string,
	): Promise<ArrayAddressSuggestionResult> => {
		try {
			const response: AxiosResponse<AddressSuggestionsResponse> =
				await httpClient.get("/predictive/address", {
					params: {
						addressType: "mailing",
						dataset: "gnaf",
						maxNumberOfResults: 10,
						query,
					},
				});

			return Result.Success(
				AddressSuggestion.ConstructList(response.data.suggest),
			);
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(
				ErrorResponseFactory.ErrorGetAddressSuggestions(err),
			);
		}
	},

	getAddress: async (id: ID): Promise<AddressResult> => {
		try {
			const response: AxiosResponse<PSMAAddressResponse> = await httpClient.get(
				`/predictive/address/${id}`,
			);

			return Result.Success(
				Address.ConstructFromPSMAAddress(response.data.address),
			);
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorGetAddress(err));
		}
	},
});
